import chalk, { type ChalkInstance } from 'chalk';

/**
 * Builds a chalk styler from a theme token value, which is either a hex color
 * or an ANSI color name (the same values Ink's `color` prop accepts). Used
 * where output is styled with chalk instead of Ink components, e.g. markdown
 * rendering.
 */
export const chalkColor = (color: string): ChalkInstance => {
  if (color.startsWith('#')) return chalk.hex(color);
  const named = (chalk as unknown as Record<string, ChalkInstance>)[color];
  return typeof named === 'function' ? named : chalk.reset;
};
